<template>
  <sfs-base-table
    :key="tableKey"
    :data-provider="$workOrdersAPI.getWorkOrders"
    provider-key="workOrders"
    :columns="translatedColumns(modelName, columns)"
    :filters="historyFilters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
    :append-to-query="appendToQuery"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    @total-rows-changed="(totalRows) => $emit('total-rows-changed', totalRows)"
  >
    <template #cell(number)="data">
      <b-link :to="{ name: 'work-order', params: { id: data.item.id } }">
        {{ data.item.number }}
      </b-link>
    </template>
    <template #cell(description)="data">
      <text-with-popover
        v-if="data.item.description != data.item.service?.name"
        :popover-id="`work-order-history-${data.item.id}-description`"
        :text="data.item.description"
      />
      <b-link
        v-if="data.item.service"
        class="font-size-sm text-prewrap"
        :to="{ name: 'service', params: { id: data.item.service.id } }"
      >
        {{ data.item.service.name }}
      </b-link>
    </template>
    <template #cell(checked_out_date)="data">
      <span v-if="data.item.checked_out_at">
        {{ data.item.checked_out_at | dateTimeFormat(data.item.location && data.item.location.time_zone) }}
      </span>
      <div
        v-if="workDuration(data.item)"
        class="font-size-sm text-secondary"
      >
        Took {{ workDuration(data.item) }}
      </div>
    </template>
    <template #cell(assigned_to_id)="data">
      <b-link
        v-if="data.item.assigned_to"
        :to="{ name: 'user', params: { id: data.item.assigned_to.id } }"
      >
        {{ data.item.assigned_to.name }}
      </b-link>
      <br>
      <span
        v-if="data.item.done_by && data.item.done_by_id != data.item.assigned_to_id"
        class="font-size-sm"
      >
        <b-link :to="{ name: 'user', params: { id: data.item.done_by.id } }">
          {{ data.item.done_by.name }}
        </b-link>
      </span>
    </template>
    <template #cell(status)="data">
      <status-badge
        :status="data.item.status"
        :sub-status="data.item.sub_status"
        :status-variants="statusVariants"
      />
      <span
        v-if="data.item.cancellation_reason"
        class="font-size-sm text-secondary"
      >
        {{ data.item.cancellation_reason | humanizedFormat | capitalizeFormat }}
      </span>
    </template>
  </sfs-base-table>
</template>

<script>
import { formatDateTimeDifference } from '@/utils/formatDateTimeDifference';
import tablePropsMixin from '@/mixins/tablePropsMixin';
import translationMixin from '@/mixins/translationMixin';
import {
  STATUS_VARIANTS,
  WORK_ORDER_HISTORY_TABLE_DEFAULT_COLUMNS,
  WORK_ORDER_MODEL_NAME,
} from '@/constants/workOrders';
import StatusBadge from '@/components/shared/StatusBadge.vue';
import TextWithPopover from '@/components/shared/TextWithPopover.vue';

export default {
  name: 'WorkOrderHistoryTable',
  components: {
    StatusBadge,
    TextWithPopover,
  },
  mixins: [tablePropsMixin, translationMixin],
  props: {
    locationId: {
      type: Number,
      required: true,
    },
    clientId: {
      type: Number,
      default: null,
    },
    columns: {
      type: Array,
      default: () => WORK_ORDER_HISTORY_TABLE_DEFAULT_COLUMNS,
    },
    appendToQuery: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: 'checked_out_date',
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modelName: WORK_ORDER_MODEL_NAME,
      statusVariants: STATUS_VARIANTS,
    };
  },
  computed: {
    historyFilters() {
      return {
        ...this.filters,
        location_id: this.locationId,
        ...(this.clientId != null ? { client_id: this.clientId } : {}),
      };
    },
  },
  methods: {
    workDuration(workOrder) {
      if (!workOrder.checked_in_at || !workOrder.checked_out_at) {
        return '';
      }

      return formatDateTimeDifference(
        workOrder.checked_in_at,
        workOrder.checked_out_at,
        { units: ['hours', 'minutes'] },
      );
    },
  },
};
</script>
